import { useGetHeaders } from "@hooks/useGetHeaders";
import { CommonCMS } from "@lib/constants/contentful";

const microcopiesWithTitles = {
    labelEU: CommonCMS.size.labelEU,
    labelUS: CommonCMS.size.labelUS,
    labelUK: CommonCMS.size.labelUK,
    labelCM: CommonCMS.size.labelCM,
    labelKR: CommonCMS.size.labelKR,
    labelCA: CommonCMS.size.labelCA,
    ariaEU: CommonCMS.size.ariaEU,
    ariaUS: CommonCMS.size.ariaUS,
    ariaUK: CommonCMS.size.ariaUK,
    ariaCM: CommonCMS.size.ariaCM,
    ariaKR: CommonCMS.size.ariaKR,
    ariaCA: CommonCMS.size.ariaCA,
    genderMale: CommonCMS.gender.male,
    genderFemale: CommonCMS.gender.female,
    guideGloves: CommonCMS.guide.gloves,
    inStock: CommonCMS.productSize.VB.inStock,
    soldOut: CommonCMS.productSize.VB.soldOut,
    OnePairLeft: CommonCMS.productSize.VB.OnePairLeft,
    GetNotified: CommonCMS.productSize.VB.GetNotified,
    SelectSize: CommonCMS.productSize.VB.SelectSize,
} as const;

const sharedMicrocopiesWithTitles = {
    sizeTitle: CommonCMS.size.title,
    onlyOneItemLeft: CommonCMS.onlyOneItemLeft,
} as const;

export const useProductSizeMicrocopies = () => {
    const pageMicrocopies = useGetHeaders({
        microcopiesWithTitles,
        source: CommonCMS.page,
    });

    const sharedMicrocopies = useGetHeaders({
        microcopiesWithTitles: sharedMicrocopiesWithTitles,
        source: CommonCMS.shared,
    });

    return {
        ...pageMicrocopies,
        ...sharedMicrocopies,
    };
};
